export default __webpack_public_path__ + "static/dataswati-f55b3896ddae15c41da90013fbbab54b.png";